import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer',
    imports: [],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {

  currentYear: number = new Date().getFullYear();

  constructor(
    private readonly router: Router
  ) { }

  public navigateToStartpage() {
    this.router.navigate(['']);
  }

}
